import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { textSizes } from 'theme/media'
import { IStyles } from '../../../theme'

const deviceSettingsAudioOutputStyles: IStyles = {
    title: {
        fontSize: textSizes.normal,
    },
    radioWrapper: {
        ...grid.row,
        ...grid.mt_md,
        ...grid.mb_md,
    },
    radio: {
        ...grid.mr_md,
    },
}

addStyles(deviceSettingsAudioOutputStyles)
export default deviceSettingsAudioOutputStyles
